<template>
	<div class="empty">
		<img class="icon" src="~assets/images/empty.png" />
		<div class="text">{{text}}</div>
	</div>
</template>

<script>
	export default{
		name: 'Empty',
		props: {
			text: {
				type: String,
				default: '暂无信息'
			}
		}
	}
</script>

<style scoped>
.empty{ display: flex; flex-direction: column; align-items: center;}
.empty>.icon{ width: 6.9rem; height: 5rem;}
.empty>.text{ height: 0.96rem; line-height: 0.96rem; text-align: center; font-size: 0.32rem; font-weight: 600; color: #333;}
</style>